import Ajax from '@utils/ajax';

export default {
  queueCheckValid(username, usernameType, options = {}) {
    return Ajax.post({
      url: `/social_link_checks/queue_check_valid`,
      data: { username: username, username_type: usernameType },
      ...options,
    });
  },

  checkValid(username, usernameType, options = {}) {
    return Ajax.get({
      url: `/social_link_checks/check_valid`,
      data: { username: username, username_type: usernameType },
      ...options,
    });
  },
};
